import { ScrollContainer } from '../../../../../ScrollContainer'
import Text from '../../../../../Text'

import * as styles from './ViewingFormSlotPickerList.module.css'

function ViewingFormSlotPickerList({ children, dayLabel, ...restProps }) {
  return (
    <div className={styles.ViewingFormSlotPickerList}>
      <Text isSecondary className={styles.caption}>
        {dayLabel}
      </Text>
      <ScrollContainer {...restProps} className={styles.list}>
        {children}
      </ScrollContainer>
    </div>
  )
}

export default ViewingFormSlotPickerList
